import classes from "../SeedLister.module.css"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

const TitleInit = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            {props.additional}
            <h2>{t("misc:SeedListing.TitleHeadline")}</h2>

            <p>
                <NavLink to="/profile" end>
                    {t("misc:SeedListing.TitleFinderIntroduction")}
                </NavLink>
            </p>
        </div>
    )
}

export default TitleInit
